/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Chat } from '../models/chat';
import { chatFileUpload } from '../fn/net/chat-file-upload';
import { ChatFileUpload$Params } from '../fn/net/chat-file-upload';
import { ChatMessage } from '../models/chat-message';
import { netChatChatsList } from '../fn/net/net-chat-chats-list';
import { NetChatChatsList$Params } from '../fn/net/net-chat-chats-list';
import { netChatChatsPartialUpdate } from '../fn/net/net-chat-chats-partial-update';
import { NetChatChatsPartialUpdate$Params } from '../fn/net/net-chat-chats-partial-update';
import { netChatChatsRetrieve } from '../fn/net/net-chat-chats-retrieve';
import { NetChatChatsRetrieve$Params } from '../fn/net/net-chat-chats-retrieve';
import { netChatChatsUnreadCountsRetrieve } from '../fn/net/net-chat-chats-unread-counts-retrieve';
import { NetChatChatsUnreadCountsRetrieve$Params } from '../fn/net/net-chat-chats-unread-counts-retrieve';
import { netChatChatsUpdate } from '../fn/net/net-chat-chats-update';
import { NetChatChatsUpdate$Params } from '../fn/net/net-chat-chats-update';
import { netChatChatsWithCustomerRetrieve } from '../fn/net/net-chat-chats-with-customer-retrieve';
import { NetChatChatsWithCustomerRetrieve$Params } from '../fn/net/net-chat-chats-with-customer-retrieve';
import { netChatChatsWithSupplierRetrieve } from '../fn/net/net-chat-chats-with-supplier-retrieve';
import { NetChatChatsWithSupplierRetrieve$Params } from '../fn/net/net-chat-chats-with-supplier-retrieve';
import { netChatMessagesCreate } from '../fn/net/net-chat-messages-create';
import { NetChatMessagesCreate$Params } from '../fn/net/net-chat-messages-create';
import { netChatMessagesDestroy } from '../fn/net/net-chat-messages-destroy';
import { NetChatMessagesDestroy$Params } from '../fn/net/net-chat-messages-destroy';
import { netChatMessagesList } from '../fn/net/net-chat-messages-list';
import { NetChatMessagesList$Params } from '../fn/net/net-chat-messages-list';
import { netChatMessagesPartialUpdate } from '../fn/net/net-chat-messages-partial-update';
import { NetChatMessagesPartialUpdate$Params } from '../fn/net/net-chat-messages-partial-update';
import { netChatMessagesRetrieve } from '../fn/net/net-chat-messages-retrieve';
import { NetChatMessagesRetrieve$Params } from '../fn/net/net-chat-messages-retrieve';
import { netChatMessagesUnreadRetrieve } from '../fn/net/net-chat-messages-unread-retrieve';
import { NetChatMessagesUnreadRetrieve$Params } from '../fn/net/net-chat-messages-unread-retrieve';
import { netChatMessagesUpdate } from '../fn/net/net-chat-messages-update';
import { NetChatMessagesUpdate$Params } from '../fn/net/net-chat-messages-update';
import { netChatUploadedFilesCreate } from '../fn/net/net-chat-uploaded-files-create';
import { NetChatUploadedFilesCreate$Params } from '../fn/net/net-chat-uploaded-files-create';
import { netChatUploadedFilesDestroy } from '../fn/net/net-chat-uploaded-files-destroy';
import { NetChatUploadedFilesDestroy$Params } from '../fn/net/net-chat-uploaded-files-destroy';
import { netChatUploadedFilesList } from '../fn/net/net-chat-uploaded-files-list';
import { NetChatUploadedFilesList$Params } from '../fn/net/net-chat-uploaded-files-list';
import { netChatUploadedFilesPartialUpdate } from '../fn/net/net-chat-uploaded-files-partial-update';
import { NetChatUploadedFilesPartialUpdate$Params } from '../fn/net/net-chat-uploaded-files-partial-update';
import { netChatUploadedFilesRetrieve } from '../fn/net/net-chat-uploaded-files-retrieve';
import { NetChatUploadedFilesRetrieve$Params } from '../fn/net/net-chat-uploaded-files-retrieve';
import { netChatUploadedFilesUpdate } from '../fn/net/net-chat-uploaded-files-update';
import { NetChatUploadedFilesUpdate$Params } from '../fn/net/net-chat-uploaded-files-update';
import { netZohoCreate } from '../fn/net/net-zoho-create';
import { NetZohoCreate$Params } from '../fn/net/net-zoho-create';
import { netZohoGetAccessTokenRetrieve } from '../fn/net/net-zoho-get-access-token-retrieve';
import { NetZohoGetAccessTokenRetrieve$Params } from '../fn/net/net-zoho-get-access-token-retrieve';
import { PaginatedChatList } from '../models/paginated-chat-list';
import { PaginatedChatMessageList } from '../models/paginated-chat-message-list';
import { PaginatedUploadedFileList } from '../models/paginated-uploaded-file-list';
import { UploadedFile } from '../models/uploaded-file';

@Injectable({ providedIn: 'root' })
export class NetService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `netChatChatsList()` */
  static readonly NetChatChatsListPath = '/net/chat/chats/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatChatsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatChatsList$Response(params?: NetChatChatsList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedChatList>> {
    return netChatChatsList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatChatsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatChatsList(params?: NetChatChatsList$Params, context?: HttpContext): Observable<PaginatedChatList> {
    return this.netChatChatsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedChatList>): PaginatedChatList => r.body)
    );
  }

  /** Path part for operation `netChatChatsRetrieve()` */
  static readonly NetChatChatsRetrievePath = '/net/chat/chats/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatChatsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatChatsRetrieve$Response(params: NetChatChatsRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<Chat>> {
    return netChatChatsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatChatsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatChatsRetrieve(params: NetChatChatsRetrieve$Params, context?: HttpContext): Observable<Chat> {
    return this.netChatChatsRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<Chat>): Chat => r.body)
    );
  }

  /** Path part for operation `netChatChatsUpdate()` */
  static readonly NetChatChatsUpdatePath = '/net/chat/chats/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatChatsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatChatsUpdate$Response(params: NetChatChatsUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Chat>> {
    return netChatChatsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatChatsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatChatsUpdate(params: NetChatChatsUpdate$Params, context?: HttpContext): Observable<Chat> {
    return this.netChatChatsUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Chat>): Chat => r.body)
    );
  }

  /** Path part for operation `netChatChatsPartialUpdate()` */
  static readonly NetChatChatsPartialUpdatePath = '/net/chat/chats/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatChatsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatChatsPartialUpdate$Response(params: NetChatChatsPartialUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Chat>> {
    return netChatChatsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatChatsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatChatsPartialUpdate(params: NetChatChatsPartialUpdate$Params, context?: HttpContext): Observable<Chat> {
    return this.netChatChatsPartialUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Chat>): Chat => r.body)
    );
  }

  /** Path part for operation `netChatChatsUnreadCountsRetrieve()` */
  static readonly NetChatChatsUnreadCountsRetrievePath = '/net/chat/chats/unread_counts/';

  /**
   * Returns the count of unread messages sent by other users
   * grouped by chat ID and the total count.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatChatsUnreadCountsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatChatsUnreadCountsRetrieve$Response(params?: NetChatChatsUnreadCountsRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: any;
}>> {
    return netChatChatsUnreadCountsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the count of unread messages sent by other users
   * grouped by chat ID and the total count.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatChatsUnreadCountsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatChatsUnreadCountsRetrieve(params?: NetChatChatsUnreadCountsRetrieve$Params, context?: HttpContext): Observable<{
[key: string]: any;
}> {
    return this.netChatChatsUnreadCountsRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: any;
}>): {
[key: string]: any;
} => r.body)
    );
  }

  /** Path part for operation `netChatChatsWithCustomerRetrieve()` */
  static readonly NetChatChatsWithCustomerRetrievePath = '/net/chat/chats/with_customer/{customer_id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatChatsWithCustomerRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatChatsWithCustomerRetrieve$Response(params: NetChatChatsWithCustomerRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<Chat>> {
    return netChatChatsWithCustomerRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatChatsWithCustomerRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatChatsWithCustomerRetrieve(params: NetChatChatsWithCustomerRetrieve$Params, context?: HttpContext): Observable<Chat> {
    return this.netChatChatsWithCustomerRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<Chat>): Chat => r.body)
    );
  }

  /** Path part for operation `netChatChatsWithSupplierRetrieve()` */
  static readonly NetChatChatsWithSupplierRetrievePath = '/net/chat/chats/with_supplier/{supplier_id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatChatsWithSupplierRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatChatsWithSupplierRetrieve$Response(params: NetChatChatsWithSupplierRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<Chat>> {
    return netChatChatsWithSupplierRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatChatsWithSupplierRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatChatsWithSupplierRetrieve(params: NetChatChatsWithSupplierRetrieve$Params, context?: HttpContext): Observable<Chat> {
    return this.netChatChatsWithSupplierRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<Chat>): Chat => r.body)
    );
  }

  /** Path part for operation `chatFileUpload()` */
  static readonly ChatFileUploadPath = '/net/chat/file_upload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `chatFileUpload()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatFileUpload$Response(params: ChatFileUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<UploadedFile>> {
    return chatFileUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `chatFileUpload$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  chatFileUpload(params: ChatFileUpload$Params, context?: HttpContext): Observable<UploadedFile> {
    return this.chatFileUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<UploadedFile>): UploadedFile => r.body)
    );
  }

  /** Path part for operation `netChatMessagesList()` */
  static readonly NetChatMessagesListPath = '/net/chat/messages/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatMessagesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatMessagesList$Response(params?: NetChatMessagesList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedChatMessageList>> {
    return netChatMessagesList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatMessagesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatMessagesList(params?: NetChatMessagesList$Params, context?: HttpContext): Observable<PaginatedChatMessageList> {
    return this.netChatMessagesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedChatMessageList>): PaginatedChatMessageList => r.body)
    );
  }

  /** Path part for operation `netChatMessagesCreate()` */
  static readonly NetChatMessagesCreatePath = '/net/chat/messages/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatMessagesCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatMessagesCreate$Response(params: NetChatMessagesCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatMessage>> {
    return netChatMessagesCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatMessagesCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatMessagesCreate(params: NetChatMessagesCreate$Params, context?: HttpContext): Observable<ChatMessage> {
    return this.netChatMessagesCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChatMessage>): ChatMessage => r.body)
    );
  }

  /** Path part for operation `netChatMessagesRetrieve()` */
  static readonly NetChatMessagesRetrievePath = '/net/chat/messages/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatMessagesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatMessagesRetrieve$Response(params: NetChatMessagesRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatMessage>> {
    return netChatMessagesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatMessagesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatMessagesRetrieve(params: NetChatMessagesRetrieve$Params, context?: HttpContext): Observable<ChatMessage> {
    return this.netChatMessagesRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChatMessage>): ChatMessage => r.body)
    );
  }

  /** Path part for operation `netChatMessagesUpdate()` */
  static readonly NetChatMessagesUpdatePath = '/net/chat/messages/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatMessagesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatMessagesUpdate$Response(params: NetChatMessagesUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatMessage>> {
    return netChatMessagesUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatMessagesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatMessagesUpdate(params: NetChatMessagesUpdate$Params, context?: HttpContext): Observable<ChatMessage> {
    return this.netChatMessagesUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChatMessage>): ChatMessage => r.body)
    );
  }

  /** Path part for operation `netChatMessagesDestroy()` */
  static readonly NetChatMessagesDestroyPath = '/net/chat/messages/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatMessagesDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatMessagesDestroy$Response(params: NetChatMessagesDestroy$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return netChatMessagesDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatMessagesDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatMessagesDestroy(params: NetChatMessagesDestroy$Params, context?: HttpContext): Observable<void> {
    return this.netChatMessagesDestroy$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `netChatMessagesPartialUpdate()` */
  static readonly NetChatMessagesPartialUpdatePath = '/net/chat/messages/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatMessagesPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatMessagesPartialUpdate$Response(params: NetChatMessagesPartialUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatMessage>> {
    return netChatMessagesPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatMessagesPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatMessagesPartialUpdate(params: NetChatMessagesPartialUpdate$Params, context?: HttpContext): Observable<ChatMessage> {
    return this.netChatMessagesPartialUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChatMessage>): ChatMessage => r.body)
    );
  }

  /** Path part for operation `netChatMessagesUnreadRetrieve()` */
  static readonly NetChatMessagesUnreadRetrievePath = '/net/chat/messages/unread/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatMessagesUnreadRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatMessagesUnreadRetrieve$Response(params?: NetChatMessagesUnreadRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatMessage>> {
    return netChatMessagesUnreadRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatMessagesUnreadRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatMessagesUnreadRetrieve(params?: NetChatMessagesUnreadRetrieve$Params, context?: HttpContext): Observable<ChatMessage> {
    return this.netChatMessagesUnreadRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChatMessage>): ChatMessage => r.body)
    );
  }

  /** Path part for operation `netChatUploadedFilesList()` */
  static readonly NetChatUploadedFilesListPath = '/net/chat/uploaded_files/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatUploadedFilesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatUploadedFilesList$Response(params?: NetChatUploadedFilesList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedUploadedFileList>> {
    return netChatUploadedFilesList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatUploadedFilesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatUploadedFilesList(params?: NetChatUploadedFilesList$Params, context?: HttpContext): Observable<PaginatedUploadedFileList> {
    return this.netChatUploadedFilesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedUploadedFileList>): PaginatedUploadedFileList => r.body)
    );
  }

  /** Path part for operation `netChatUploadedFilesCreate()` */
  static readonly NetChatUploadedFilesCreatePath = '/net/chat/uploaded_files/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatUploadedFilesCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatUploadedFilesCreate$Response(params: NetChatUploadedFilesCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<UploadedFile>> {
    return netChatUploadedFilesCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatUploadedFilesCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatUploadedFilesCreate(params: NetChatUploadedFilesCreate$Params, context?: HttpContext): Observable<UploadedFile> {
    return this.netChatUploadedFilesCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<UploadedFile>): UploadedFile => r.body)
    );
  }

  /** Path part for operation `netChatUploadedFilesRetrieve()` */
  static readonly NetChatUploadedFilesRetrievePath = '/net/chat/uploaded_files/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatUploadedFilesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatUploadedFilesRetrieve$Response(params: NetChatUploadedFilesRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<UploadedFile>> {
    return netChatUploadedFilesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatUploadedFilesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatUploadedFilesRetrieve(params: NetChatUploadedFilesRetrieve$Params, context?: HttpContext): Observable<UploadedFile> {
    return this.netChatUploadedFilesRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<UploadedFile>): UploadedFile => r.body)
    );
  }

  /** Path part for operation `netChatUploadedFilesUpdate()` */
  static readonly NetChatUploadedFilesUpdatePath = '/net/chat/uploaded_files/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatUploadedFilesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatUploadedFilesUpdate$Response(params: NetChatUploadedFilesUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<UploadedFile>> {
    return netChatUploadedFilesUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatUploadedFilesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatUploadedFilesUpdate(params: NetChatUploadedFilesUpdate$Params, context?: HttpContext): Observable<UploadedFile> {
    return this.netChatUploadedFilesUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<UploadedFile>): UploadedFile => r.body)
    );
  }

  /** Path part for operation `netChatUploadedFilesDestroy()` */
  static readonly NetChatUploadedFilesDestroyPath = '/net/chat/uploaded_files/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatUploadedFilesDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatUploadedFilesDestroy$Response(params: NetChatUploadedFilesDestroy$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return netChatUploadedFilesDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatUploadedFilesDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netChatUploadedFilesDestroy(params: NetChatUploadedFilesDestroy$Params, context?: HttpContext): Observable<void> {
    return this.netChatUploadedFilesDestroy$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `netChatUploadedFilesPartialUpdate()` */
  static readonly NetChatUploadedFilesPartialUpdatePath = '/net/chat/uploaded_files/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netChatUploadedFilesPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatUploadedFilesPartialUpdate$Response(params: NetChatUploadedFilesPartialUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<UploadedFile>> {
    return netChatUploadedFilesPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netChatUploadedFilesPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  netChatUploadedFilesPartialUpdate(params: NetChatUploadedFilesPartialUpdate$Params, context?: HttpContext): Observable<UploadedFile> {
    return this.netChatUploadedFilesPartialUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<UploadedFile>): UploadedFile => r.body)
    );
  }

  /** Path part for operation `netZohoCreate()` */
  static readonly NetZohoCreatePath = '/net/zoho/{var}/';

  /**
   * Performs call to the Zoho API server and forwards the response back.
   *
   *     /net/zoho/ {var} /
   *
   *     var = get | post | patch | delete
   *
   * GET content example:
   *
   *     -H "Zoho-Forward-URL: /api/v1/tickets"
   *
   *     -H "Content-Type: application/json"
   *
   *     -d {"param1": 0, "param2": 0}
   *
   *
   * POST/PATCH content example:
   *
   *     -H "Zoho-Forward-URL: /api/v1/tickets"
   *
   *     -H "Content-Type: application/json"
   *
   *     -d {"param1": 0, "param2": 0}
   *
   *     -F 'file=@"/somepath/1.png"'
   *
   *
   * DELETE content example:
   *
   *     -H "Zoho-Forward-URL: /api/v1/tickets/ticket-id/resolution"
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netZohoCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  netZohoCreate$Response(params: NetZohoCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return netZohoCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Performs call to the Zoho API server and forwards the response back.
   *
   *     /net/zoho/ {var} /
   *
   *     var = get | post | patch | delete
   *
   * GET content example:
   *
   *     -H "Zoho-Forward-URL: /api/v1/tickets"
   *
   *     -H "Content-Type: application/json"
   *
   *     -d {"param1": 0, "param2": 0}
   *
   *
   * POST/PATCH content example:
   *
   *     -H "Zoho-Forward-URL: /api/v1/tickets"
   *
   *     -H "Content-Type: application/json"
   *
   *     -d {"param1": 0, "param2": 0}
   *
   *     -F 'file=@"/somepath/1.png"'
   *
   *
   * DELETE content example:
   *
   *     -H "Zoho-Forward-URL: /api/v1/tickets/ticket-id/resolution"
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netZohoCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netZohoCreate(params: NetZohoCreate$Params, context?: HttpContext): Observable<void> {
    return this.netZohoCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `netZohoGetAccessTokenRetrieve()` */
  static readonly NetZohoGetAccessTokenRetrievePath = '/net/zoho/get_access_token/';

  /**
   * Returns an up-to-date Zoho access token.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `netZohoGetAccessTokenRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  netZohoGetAccessTokenRetrieve$Response(params?: NetZohoGetAccessTokenRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return netZohoGetAccessTokenRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns an up-to-date Zoho access token.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `netZohoGetAccessTokenRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  netZohoGetAccessTokenRetrieve(params?: NetZohoGetAccessTokenRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.netZohoGetAccessTokenRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
